import { Store } from 'src/store/index';

const getProductTypeId = (store: Store) => store.design.productTypeId;

export default getProductTypeId;
